import React, { Component } from 'react';
import './App.css';
import {Name, Info} from './extras.js';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Name></Name>
        <Info></Info>      
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js